import { render, staticRenderFns } from "./penyerahan_berkas_pelayanan_selesai_wp.vue?vue&type=template&id=15395a24&"
import script from "./penyerahan_berkas_pelayanan_selesai_wp.vue?vue&type=script&lang=js&"
export * from "./penyerahan_berkas_pelayanan_selesai_wp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports